import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { AnalyticsService } from '@core/services/analytics/analytics.service';

@Directive({
  selector: '[appPopup]'
})
export class PopupDirective implements AfterViewInit {
  constructor(
    private el: ElementRef<HTMLIonContentElement>,
    private analyticsService: AnalyticsService
  ) {}

  ngAfterViewInit() {
    this.pushEvent();
  }

  private pushEvent(): void {
    this.analyticsService.pushPopupEvent({
      title: this.getTitleText(),
      content: this.getContentText(),
      ctaTexts: this.getCtaTexts()
    });
  }

  private getTitleText(): string {
    const el = this.el.nativeElement.querySelector('.fullscreen-body h2');

    return el && el.textContent;
  }

  private getContentText(): string {
    let text = '';

    this.el.nativeElement.querySelectorAll('p').forEach(el => {
      if (typeof el.textContent === 'string') {
        text += el.textContent;
      }
    });

    return text;
  }

  private getCtaTexts(): string[] {
    const texts: string[] = [];

    this.el.nativeElement.querySelectorAll('.footer ion-button').forEach(el => {
      if (typeof el.textContent === 'string') {
        texts.push(el.textContent);
      }
    });

    return texts;
  }
}
